import { AccordionHeader, AccordionItem, AccordionPanel, mergeClasses } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import INavigationArea from "../../../models/navigation/INavigationArea";
import INavigationSection from "../../../models/navigation/INavigationSection";
import MobileSection from "./MobileSection";
import { useMobileStyles } from "./MobileStyles";

interface IMobileArea {
    index: number;
    area: INavigationArea;
    onNavigate: () => void;
}

const ACCENT_CLASS_KEYS = [
    "accordionHeaderAccentBlue",
    "accordionHeaderAccentLavender",
    "accordionHeaderAccentMint",
    "accordionHeaderAccentPeach",
    "accordionHeaderAccentSunflower",
] as const;

export default function MobileArea(props: IMobileArea) {
    const { area } = props;

    const { t } = useTranslation("navigation");
    const styles = useMobileStyles();

    const accentKey = ACCENT_CLASS_KEYS[(props.index - 2) % ACCENT_CLASS_KEYS.length];
    const dotKey = (["dotBlue", "dotLavender", "dotMint", "dotPeach", "dotSunflower"] as const)[
        (props.index - 2) % ACCENT_CLASS_KEYS.length
    ];

    return (
        <AccordionItem value={props.index}>
            <AccordionHeader
                as="div"
                expandIconPosition="end"
                className={mergeClasses(styles.accordionHeader, styles[accentKey])}
            >
                <span className={styles.button}>
                    <span className={mergeClasses(styles.dot, styles[dotKey])} aria-hidden="true" />
                    {area.name}
                </span>
            </AccordionHeader>
            <AccordionPanel>
                {
                    area.sections
                        .sort((a, b) => a.order - b.order)
                        .map((nav: INavigationSection, index: number) => (
                            <MobileSection key={index} section={nav} area={area} onNavigate={props.onNavigate} />
                        ))
                }
            </AccordionPanel>
        </AccordionItem>
    );
}